<template>
<section class="mypage-confirm">
	<h1 class="mainTitle">마이페이지</h1>
	<article class="body">
	<h2>위원회 승인 요청목록</h2>
	<div class="tabTitle">
		<a href="#" class="selected">공정도 승인 요청목록</a>
		<a href="#">프로토콜 승인 요청 목록</a>
	</div>

	<table>
		<thead>
			<tr>
				<th>요청일</th><th>분야</th><th>공정도명</th><th>승인여부</th><th>처리일/처리자</th><th>문서 공개 일정</th><th>거절사유</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>2022-10-06<br/>15:27:03</td> 
				<td>스마트IT</td> 
				<td class="title">[Tetradymite계] Ag-decorated (Bi1-xSbx)2Te3</td> 
				<td><span class="status wait">대기</span></td> 
				<td>2022-10-07 15:27:03<br/>/김기평</td> 
				<td>2022-10-20</td> 
				<td></td> 
			</tr>
			<tr>
				<td>2022-10-06<br/>15:27:03</td> 
				<td>스마트IT</td> 
				<td class="title">[Tetradymite계] Ag-decorated (Bi1-xSbx)2Te3</td> 
				<td><span class="status denied">거절</span></td> 
				<td>2022-10-07 15:27:03<br/>/김기평</td> 
				<td>2022-10-20</td> 
				<td>거절 사유 거절 사유 거절 사유 거절 사유 거절 사유 거절 사유 거절 사유 거절 사유 거절 사유 거절 사유 거절 사유</td> 
			</tr>
			<tr>
				<td>2022-10-06<br/>15:27:03</td> 
				<td>스마트IT</td> 
				<td class="title">[Tetradymite계] Ag-decorated (Bi1-xSbx)2Te3</td> 
				<td><span class="status confirm">승인</span></td> 
				<td>2022-10-07 15:27:03<br/>/김기평</td> 
				<td>2022-10-20</td> 
				<td></td> 
			</tr>
			
		</tbody>
	</table>
	<Pagination :pageCnt="1" :pageTotalCnt="10" :size="9"/>
	</article>
</section>

</template>

<script>
import Pagination from '../../common/Pagination.vue';

export default {
	components: {Pagination},
	data() {
		return {}
	}
}

</script>

<style lang="scss">
.mainTitle {
	display: flex; align-items: center; justify-content: center;
	height: 224px;
	@include text-prt-sb; font-size: 32px;
}

.mypage-confirm {
	.body {
		max-width: 1525px;
		margin: 0 auto;
		@include text-prt;
		h2 {
			border-bottom: 1px solid #999;
			padding: 0  0 22px 0;
			font-size: 20px;
			@include text-prt-b;
		}
		.tabTitle {
			display: flex; align-items: center; justify-content: space-around;
			margin-bottom: 50px;
			height: 50px;
			a {
				display: block;
				text-decoration: none;
				font-size: 16px;
				color: #999;
				@include text-prt-sb;
				&.selected {
					color: #00B8E7;
				}
			}
		}
		table {
			width: 100%;
			th {
				padding: 13px 10px;
				min-height: 44px;
				border-bottom: 1px solid #333;
			}
			td {
				padding: 10px;
				min-height: 44px;
				border-bottom: 1px solid #ddd;
				vertical-align: middle;
				text-align: center;
				font-weight: 500;
				&.title {
					text-align: left;
				}
				&:nth-child(3) {
					max-width: 350px;
				}
				&:last-child {
					max-width: 250px;
				}
			}
			span.status {
				display: inline-flex;
				padding: 4px 8px;
				border-radius: 3px;
				&.denied { background: #FFF7DA; color: #F0BD22; }
				&.wait { background: #FFEFEB; color: #F64E4E; }
				&.confirm { background: #E9F9EF; color: #50AF79; }
			}
		}
	}
}
</style>